import {message} from 'antd'

const hostname = window.location.hostname;
const prodHost = 'ysdinghuo';
const testHost = 'yimaideng';
const devHost = `http://${hostname}`;
const isCustomHost = (hostname.indexOf(prodHost) === -1 && hostname.indexOf(testHost) === -1 && hostname.indexOf('192.168') === -1);
const UrlUtil = {
    getHost(){
        if (process.env.API_ENV === 'production') {
            return prodHost;
        } else if (process.env.API_ENV === 'test') {
            return testHost;
        } else {
            return devHost;
        }
    },
    getAPI() {
        if (process.env.API_ENV === 'production') {
            return `https://api.${prodHost}.com`;
        } else if (process.env.API_ENV === 'test') {
            return `http://api.yimaideng.cn`;
        } else {
            return `${devHost}:8990`;
            // return `https://api.ysdinghuo.com`;
            // return `http://192.168.0.124:7002`;
            // return `http://api.yimaideng.cn`;
            // return `https://api.qipeidd.com`;
        }
    },
    getAccountUrl: (companyID) => {
        if (isCustomHost) {
            return window.location.origin;
        } else if (process.env.API_ENV === 'production') {
            return companyID ? `https://store${companyID}.${prodHost}.com` : `https://account.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return companyID ? `http://store${companyID}.${testHost}.cn` : `http://account.${testHost}.cn`
        } else if (window.location.href.indexOf('192.168')) {
            return `${devHost}:8993`;
        }
    },
    getPCShopUrl: (companyID) => {
        if (!companyID) return message.info('缺少企业id');
        if (isCustomHost) {
            return window.location.origin;
        } else if (process.env.API_ENV === 'production') {
            return `https://store${companyID}.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://store${companyID}.${testHost}.cn`
        } else if (window.location.href.indexOf('192.168')) {
            return `${devHost}:8997`;
        }
    },
    getPCMgrUrl: (companyID) => {
        if (!companyID) return message.info('缺少企业id');
        if (isCustomHost) {
            return window.location.origin;
        } else if (process.env.API_ENV === 'production') {
            return `https://store${companyID}.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://store${companyID}.${testHost}.cn`
        } else if (window.location.href.indexOf('192.168')) {
            return `${devHost}:8990`;
        }
    },
    getMShopUrl: () => {
        if (process.env.API_ENV === 'production') {
            return `https://m.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://m.${testHost}.cn`
        } else {
            return `${devHost}:8991`;
        }
    },

    getMMgrUrl() {
        if (process.env.API_ENV === 'production') {
            // return `http://mtest.qipeidd.cn`;
            return `https://mgr.${prodHost}.com`;
        } else if (process.env.API_ENV === 'test') {
            return `http://mgr.${testHost}.cn`;
        } else if (process.env.API_ENV === 'development') {
            return `${devHost}:8996`;
        }
    },
    getLightUrl: () => {
        if (process.env.API_ENV === 'production') {
            return `https://pd.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://pd.${testHost}.cn`
        } else {
            return `${devHost}:8999`;
        }
    },
    getBitMapUrl: () => {
        if (process.env.API_ENV === 'production') {
            return `https://point.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://point.${testHost}.cn`
        } else {
            return `${devHost}:5003`;
        }
    },
};
export default UrlUtil;
